import React, { Component } from 'react';
import { Button, DatePicker, Form, Input } from 'antd';
import moment from 'moment';
import './expenses.less';

const FormItem = Form.Item;
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD';

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  onChange = e => {
    this.props.onChange(e.target.value);
  };

  onSearch = () => {
    const data = this.props.form.getFieldsValue();
    let params = {};
    const { date } = data;
    if (date) {
      params = {
        beginDate: moment(date[0]).format('YYYY-MM-DD'),
        endDate: moment(date[1]).format('YYYY-MM-DD'),
      };
    }
    params = {
      ...params,
      condition: data.condition || '',
    };
    this.props.onSearch(params);
  };

  render() {
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <div className="expense-search-form">
        <Form layout="inline" style={{ textAlign: 'right' }}>
          <FormItem>
            {getFieldDecorator('condition', {
              initialValue: this.props.condition || null,
            })(<Input placeholder="请输入关键字搜索" />)}
          </FormItem>
          <FormItem>
            {getFieldDecorator('date', {
              initialValue: this.props.beginDate
                ? [moment(this.props.beginDate, dateFormat), moment(this.props.endDate, dateFormat)]
                : null,
            })(<RangePicker format={dateFormat} allowClear={false} />)}
          </FormItem>
          <FormItem>
            <Button type="primary" onClick={this.onSearch}>
              搜索
            </Button>
            {/* <Button
              style={{ marginLeft: "8px", marginRight: "-16px" }}
              onClick={this.onReset}
            >
              重置
            </Button> */}
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Manage);



// WEBPACK FOOTER //
// ./src/components/administrative/FormSearch.js